export enum NotificationEventResult {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
